/* eslint-disable max-len */
import styled, { css } from 'styled-components';
import Form from '../../components/FormWrapper';

export const AcceptTermsContainer = styled.div`
  padding: 11px 26px 26px;
  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const FormWrapper = styled(Form)`
  display: flex !important;
  flex-wrap: wrap;
  .text-bold {
    div {
      input {
        font-weight: bold;
      }
    }
  }
`;

export const AcceptTermsTitle = styled.h3`
  font-size: 1.7rem;
  line-height: 1.7rem;
  font-family: 'Unimed-Slab-Bold';
  text-align: left;
  color: ${(props) => props.theme.colors.text.primary};
  margin-bottom: 56px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`;

export const AcceptTermsContent = styled.section`
  max-height: calc(100vh - 360px);
  overflow-y: auto;
  p {
    font-size: 1rem;
    text-align: left;
    font-family: 'Unimed-Sans-Book';
    color: ${(props) => props.theme.colors.text.primary};
    /* & + p {
      margin-top: 1rem;
    } */
  }
`;
export const AcceptTermsFooter = styled.footer`
  margin-top: 32px;
  form {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
      flex-direction: column;
      > button {
        margin-top: 16px;
        width: 100%;
      }
    }
  }
`;

export const Title = styled.h1`
  grid-column: 2/10;
  margin: 30px 0;
  font-family: 'Unimed-Slab-Bold';
  text-align: center;
  font-size: 2.55rem;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.palet.institutional6};
  @media (max-width: 768px) {
    grid-column: 1;
    margin: 30px;
  }
`;

export const PendingTermAccept = styled.p`
  grid-column: 2/10;
  margin: 30px 0;
  font-family: 'Unimed-Slab-Bold';
  text-align: center;
  font-size: 1.7rem;
  color: ${(props) => props.theme.colors.text.grayishToWhite};
  cursor: pointer;
  @media (max-width: 768px) {
    grid-column: 1;
    margin: 30px;
  }
`;

interface StepContainerProps {
  defineHeight?: string;
}

export const Steps = styled.section<StepContainerProps>`
  position: relative;
  grid-column: 2/10;
  margin-bottom: 30px;
  ${(props) =>
    props.defineHeight &&
    css`
      height: ${props.defineHeight};
    `}
  @media(max-width: 768px) {
    grid-column: 1;
  }
`;

interface StepsProps {
  show: boolean;
}
const initialStateSteps = css`
  left: 0;
  top: 0;
  width: 100%;
  position: absolute;
  transform: translateX(-20px);
  visibility: hidden;
  opacity: 0;
  transition: 300ms;
  height: 0;
  overflow: hidden;
`;
const showSteps = css`
  transform: translateX(0);
  visibility: visible;
  opacity: 1;
  height: initial;
  overflow: initial;
`;

export const Step1 = styled.section<StepsProps>`
  ${initialStateSteps}

  ${(props) => props.show && showSteps}

  form {
    display: flex;
    flex-wrap: wrap;

    > button {
      margin-left: auto;
      padding-left: 16px;
      padding-right: 16px;
    }
    @media (max-width: 768px) {
      > div {
        &:nth-child(3),
        &:nth-child(5) {
          width: auto;
          flex: 1 1 35%;
        }
        &:nth-child(4),
        &:nth-child(6) {
          width: auto;
          flex: 1 1 55%;
        }
      }
      > button {
        width: 100%;
      }
    }
  }
`;

interface CheckboxGroupProps {
  error?: string;
}

export const CheckboxGroup = styled.div<CheckboxGroupProps>`
  padding: 16px;
  border: 1px solid ${(props) => props.theme.colors.text.secondary};
  border-radius: 5px;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  grid-column: 1/3;
  position: relative;
  > span {
    text-align: left;
    font-family: 'Unimed-Sans-Bold';
    font-size: 1rem;
    color: ${(props) => props.theme.colors.text.grayishToWhite};
  }
  ${(props) =>
    !!props.error &&
    css`
      border-color: red;
    `}
  @media(max-width: 768px) {
    grid-column: 1;
  }
`;

export const Error = styled.div`
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg width='22' height='19' viewBox='0 0 22 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.36333 1.9188L1.25652 15.4525C1.08903 15.7396 1.00097 16.0746 1.00001 16.4C0.999051 16.735 1.08519 17.07 1.25077 17.3572C1.41635 17.6443 1.65563 17.8931 1.94372 18.0558C2.23181 18.2281 2.55915 18.3239 2.89319 18.3239H19.1068C19.4408 18.3239 19.7682 18.2281 20.0563 18.0558C20.3444 17.8931 20.5836 17.6443 20.7492 17.3572C20.9148 17.07 21.0009 16.735 21 16.4C20.999 16.0746 20.911 15.7396 20.7435 15.4525L12.6367 1.9188C12.4663 1.64123 12.2261 1.40199 11.9389 1.23928C11.6527 1.08614 11.3292 1 11 1C10.6708 1 10.3473 1.08614 10.0611 1.23928C9.77394 1.40199 9.5337 1.64123 9.36333 1.9188Z' stroke='%23ED1651' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M11 6.83853V10.667' stroke='%23ED1651' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M11 14.4955H11.01' stroke='%23ED1651' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-size: contain;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  cursor: pointer;

  span {
    visibility: hidden;
    opacity: 0;
    transform: translateY(20px);
    transition: 300ms !important;
    position: absolute;
    white-space: nowrap;
    right: -20px;
    top: -54px;
    background: ${(props) => props.theme.colors.palet.institutional7};
    color: ${(props) => props.theme.colors.text.inverse};
    font-family: 'Unimed-Sans-SemiBold';
    font-size: 1rem;
    padding: 6px 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 4px rgba(255, 15, 100, 0.3);

    &::before {
      content: '';
      position: absolute;
      bottom: -10px;
      right: 20px;
      border: 5px solid ${(props) => props.theme.colors.palet.institutional7};
      border-right-color: transparent;
      border-bottom-color: transparent;
    }

    @media (max-width: 768px) {
      max-width: 90vw;
      white-space: normal;
      width: max-content;
    }
  }

  &:hover {
    span {
      transition: 300ms;
      visibility: visible;
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const Step2 = styled.section<StepsProps>`
  ${initialStateSteps}

  ${(props) => props.show && showSteps}

  form {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: flex-end;
    > div {
      flex: 1;
    }
    > h3 {
      font-size: 1.7rem;
      line-height: 1.7rem;
      font-family: 'Unimed-Slab-Bold';
      text-align: center;
      color: ${(props) => props.theme.colors.text.primary};
      margin-bottom: 56px;
      width: 100%;

      @media (max-width: 768px) {
        margin-bottom: 16px;
      }
    }
    > p {
      font-size: 1rem;
      text-align: center;
      font-family: 'Unimed-Sans-Bold';
      color: ${(props) => props.theme.colors.text.grayishToWhite};
      margin-bottom: 32px;
      flex: 1 0 100%;
    }
    > button {
      text-transform: uppercase;
    }

    @media (max-width: 768px) {
      > div:nth-of-type(1) {
        width: 100%;
        flex: 1 0 100%;
      }
      > button {
        flex: 1;
      }
    }
  }
`;

export const Step3 = styled.section<StepsProps>`
  ${initialStateSteps}

  ${(props) => props.show && showSteps}

  form {
    display: flex;
    flex-wrap: wrap;

    > div:last-child {
      display: flex;
      width: 100%;
      justify-content: space-between;
      > button {
        min-width: 150px;
        text-transform: uppercase;
      }
    }

    @media (max-width: 768px) {
    }
  }
`;

export const TitleIntern = styled.h2`
  font-family: 'Unimed-Sans-SemiBold';
  font-size: 1.6rem;
  line-height: 1.6rem;

  text-align: left;
  letter-spacing: -1.19px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.palet.institutional};
  margin-bottom: 8px;
  @media (max-width: 768px) {
    font-family: 'Unimed-Sans-Bold';
    font-size: 1rem;
    line-height: 1rem;
    text-align: center;
  }
`;
